import "./App.css";
import Rotas from "./routes/routes";

function App() {
  return (
    <div className="App">
      <Rotas />
    </div>
  );
}

export default App;
